import api from '@/apis/su/sUIncrementDecrementAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('sUIncrement', api);

const state = {
  ...crud.state,
  _config: {
    table: 'su_increment_decrement',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
